import React from 'react';
import {
  BOOK_TOOLS,
  BOOK_TOOL_COMPENDIUM,
  BOOK_TOOL_NAMES,
  BOOK_TOOL_RESEARCH,
  BOOK_TOOL_STORY_PROGRESS,
} from '../../utils/writerCopy';
import { useBookTools } from './bookTools';
import './BookToolsGroup.css';

const CHOICES = [
  { id: 'names', label: BOOK_TOOL_NAMES, enabled: (tools) => tools.namesEnabled },
  { id: 'learn', label: BOOK_TOOL_RESEARCH, enabled: (tools) => tools.referenceEnabled },
  { id: 'captures', label: BOOK_TOOL_COMPENDIUM, enabled: (tools) => tools.referenceEnabled },
  { id: 'progress', label: BOOK_TOOL_STORY_PROGRESS, enabled: (tools) => tools.progressEnabled },
];

function BookToolIcon({ id }) {
  const common = {
    viewBox: '0 0 16 16',
    width: '16',
    height: '16',
    'aria-hidden': 'true',
    focusable: 'false',
  };
  const stroke = {
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: '1.5',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  };
  if (id === 'names') {
    return (
      <svg {...common}>
        <circle {...stroke} cx="8" cy="5" r="2.25" />
        <path {...stroke} d="M3.5 13.25c.7-2.35 2.35-3.5 4.5-3.5s3.8 1.15 4.5 3.5" />
      </svg>
    );
  }
  if (id === 'learn') {
    return (
      <svg {...common}>
        <circle {...stroke} cx="7" cy="7" r="3.25" />
        <path {...stroke} d="M9.6 9.6L13 13" />
      </svg>
    );
  }
  if (id === 'captures') {
    return (
      <svg {...common}>
        <path {...stroke} d="M2.5 3.5h4.2c.4 0 .8.3.8.8v8.2H3.2c-.5 0-1-.4-1-.9V4.3c0-.4.1-.8.3-.8z" />
        <path {...stroke} d="M13.5 3.5H9.3c-.4 0-.8.3-.8.8v8.2h4.3c.5 0 1-.4 1-.9V4.3c0-.4-.1-.8-.3-.8z" />
        <path {...stroke} d="M8 3.5v9" />
      </svg>
    );
  }
  return (
    <svg {...common}>
      <path {...stroke} d="M2.5 13.5h11" />
      <path {...stroke} d="M4 13.5V8.5" />
      <path {...stroke} d="M8 13.5V4" />
      <path {...stroke} d="M12 13.5V6.5" />
    </svg>
  );
}

/**
 * Quiet title-row doors for the four book tools.
 * Hidden where the right slot is not there to open.
 */
export default function BookToolsGroup() {
  const tools = useBookTools();
  if (!tools.available) return null;

  return (
    <div className="book-tools" role="group" aria-label={BOOK_TOOLS}>
      {CHOICES.map((choice) => {
        const enabled = Boolean(choice.enabled(tools));
        const pressed = enabled && tools.activeId === choice.id;
        return (
          <button
            key={choice.id}
            type="button"
            className="book-tools__btn"
            aria-pressed={pressed ? 'true' : 'false'}
            disabled={!enabled}
            onClick={() => {
              if (enabled) tools.select(choice.id);
            }}
          >
            <BookToolIcon id={choice.id} />
            <span>{choice.label}</span>
          </button>
        );
      })}
    </div>
  );
}
